import type * as React from 'react';
import { put } from '@Domain/Api';
import type { BeneficiaryPayload } from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryFetched';
import beneficiaryUpdated, {
	type BeneficiaryUpdatedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryUpdated';
import beneficiaryUpdateFailed, {
	type BeneficiaryUpdateFailedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryUpdateFailed';
import type UpdateBeneficiary from '@Application/Beneficiaries/Beneficiaries/Commands/UpdateBeneficiary';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = BeneficiaryUpdatedAction | BeneficiaryUpdateFailedAction;

export default (command: UpdateBeneficiary) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<BeneficiaryPayload>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/beneficiaries/${command.beneficiaryId}`,
				command.toJSON(),
			);

			const action = beneficiaryUpdated(payload, command.facilityId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
